import React from 'react';

export const LoadingSpinner = ({ size = 'default', className = '' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    default: 'w-8 h-8 border-2',
    lg: 'w-12 h-12 border-3',
  };

  return (
    <div className={`flex items-center justify-center ${className}`} data-testid="loading-spinner">
      <div
        className={`${sizeClasses[size]} border-muted border-t-primary rounded-full animate-spin`}
      />
    </div>
  );
};

export const PageLoader = () => {
  return (
    <div className="min-h-[50vh] flex items-center justify-center" data-testid="page-loader">
      <div className="text-center">
        <LoadingSpinner size="lg" />
        <p className="mt-4 text-muted-foreground font-mono text-sm uppercase tracking-widest">Loading...</p>
      </div>
    </div>
  );
};

export const CardSkeleton = () => {
  return (
    <div className="bg-card border border-border animate-pulse" data-testid="card-skeleton">
      <div className="aspect-[4/5] bg-zinc-800" />
      <div className="flex border-t border-border divide-x divide-border">
        <div className="flex-1 p-3">
          <div className="h-3 w-8 bg-zinc-800 mx-auto mb-1" />
          <div className="h-5 w-10 bg-zinc-800 mx-auto" />
        </div>
        <div className="flex-1 p-3">
          <div className="h-3 w-8 bg-zinc-800 mx-auto mb-1" />
          <div className="h-5 w-10 bg-zinc-800 mx-auto" />
        </div>
        <div className="flex-1 p-3">
          <div className="h-3 w-8 bg-zinc-800 mx-auto mb-1" />
          <div className="h-5 w-10 bg-zinc-800 mx-auto" />
        </div>
      </div>
    </div>
  );
};
